import { Box, Grid, Skeleton } from '@mui/material';
import Typography from '@mui/material/Typography';
import React, { memo, useContext } from 'react';
import { styled } from '@mui/material/styles';
import AddSimulationButton from 'routes/HumanResourcesModule/Simulation/SimulationHome/components/AddSimulationButton';
import SimulationItem from 'routes/HumanResourcesModule/Simulation/SimulationHome/components/SimulationItem/SimulationItem';
import { useGetAllHrSimulations } from 'routes/HumanResourcesModule/Simulation/helpers/hooks/simulation';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { HrPage } from 'routes/HumanResourcesModule/components/ui/HrPage';
import HistoricalOrgChartHrContext from 'routes/HumanResourcesModule/Simulation/contexts/ObsoleteOrgChartSimulationContext';

const StySimulationHeader = styled(Box, {
    name: 'StySimulationHeader',
})({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
});

function LoadingPage(): React.ReactElement {
    const { t } = useTranslation();
    return (
        <HrPage title={t('header.simulations')}>
            <StySimulationHeader>
                <Typography variant="h5" sx={{ width: '20%' }}>
                    <Skeleton />
                </Typography>
            </StySimulationHeader>
            <Box>
                <Grid container spacing={2}>
                    {[1, 2, 3, 4].map((item) => (
                        <Grid item xs={12} sm={6} md={4} key={item}>
                            <Skeleton
                                variant="rectangular"
                                sx={{
                                    borderRadius: '4px',
                                    height: '12rem',
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </HrPage>
    );
}

function SimulationHome(): React.ReactElement {
    const { t } = useTranslation();
    const { isLoading } = useContext(HistoricalOrgChartHrContext);
    const { data: hrSimulationsData, isLoading: areHrSimulationsLoading } =
        useGetAllHrSimulations();

    if (areHrSimulationsLoading || isLoading) {
        return <LoadingPage />;
    }
    const sortedHrSimulations =
        _(hrSimulationsData).sortBy('id').reverse().value() || [];
    return (
        <HrPage title={t('header.simulations')}>
            <StySimulationHeader>
                <Typography
                    variant="h5"
                    display="inline"
                    sx={{ marginRight: '1em' }}
                >
                    {t('humanResources.simulation.selectSimulation')}
                </Typography>
            </StySimulationHeader>
            <Box>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                        <AddSimulationButton />
                    </Grid>
                    {sortedHrSimulations.map((item) => (
                        <Grid item xs={12} sm={6} md={4} key={item.id}>
                            <SimulationItem hrSimulation={item} />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </HrPage>
    );
}

export default memo(SimulationHome);
